const isDotNet = () => {
  if (
    Number(window.location.port) === 5055 &&
    (
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1'
    )
  ) {
    return true;
  }
  return false;
};

export default isDotNet;
